import {useState, useRef, useEffect} from 'react';
import config from '../../../config';
import SelectModal, {SelectedLabel} from '../SelectModal';
import styled from 'styled-components';

let now = new Date();
let nowYear = now.getFullYear();

const Wrap = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const years = (() => {
  let yearItems = [];
  for (let y = config.report.min_year; y <= nowYear; y++) {
    yearItems.push(`${y}`);
  }
  yearItems.reverse();
  return yearItems;
})();

const months = (() => {
  let strs = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return strs.map(s => {
    return s.toUpperCase();
  });
})();

export default function ReportQuerySelector({query, onChange}) {
  const [detached, setDetached] = useState(false);
  const changeTimerRef = useRef(null);
  const [year, setYear] = useState(query.year);
  const [month, setMonth] = useState(query.month);

  const [yearModalIsOpen, setYearModalIsOpen] = useState(false);
  const [monthModalIsOpen, setMonthModalIsOpen] = useState(false);

  useEffect(() => {
    setDetached(false);
    return () => {
      setDetached(true);
    };
  }, []);

  const onClickYear = () => {
    setYearModalIsOpen(true);
  };

  const onClickMonth = () => {
    setMonthModalIsOpen(true);
  };

  const closeYearModal = () => {
    setYearModalIsOpen(false);
  };

  const closeMonthModal = () => {
    setMonthModalIsOpen(false);
  };

  const yearItemSelect = (index) => {
    setYearModalIsOpen(false);
    setYear(parseInt(years[index], 10));
  };

  const monthItemSelect = (index) => {
    setMonthModalIsOpen(false);
    setMonth(index + 1);
  };

  useEffect(() => {
    if (detached) {
      return;
    }
    if (year == query.year && month == query.month) {
      return;
    }

    setYear(query.year);
    setMonth(query.month);
  }, [query.year, query.month]);

  useEffect(() => {
    if (detached) {
      return;
    }
    if (year == query.year && month == query.month) {
      return;
    }

    if (changeTimerRef.current) {
      clearTimeout(changeTimerRef.current);
    }

    changeTimerRef.current = setTimeout(() => {
      if (detached) {
        return;
      }

      onChange({
        year,
        month,
      });
    }, 1000);
  }, [year, month]);

  return (
      <Wrap>
        <SelectedLabel onClick={onClickYear}
                       style={{
                         width: 120,
                       }}
        >{year}</SelectedLabel>
        <SelectModal
            title="Year"
            candidates={years}
            selectedIndex={years.reduce((p, c, i) => {
              if (p >= 0) {
                return p;
              }
              if (parseInt(c, 10) == year) {
                return i;
              }
              return p;
            }, -1)}
            closeModal={closeYearModal}
            modalIsOpen={yearModalIsOpen}
            itemSelect={yearItemSelect}
        />

        <SelectedLabel onClick={onClickMonth}
                       style={{
                         width: 120,
                       }}
        >{months[month -
        1]}</SelectedLabel>
        <SelectModal
            title="Month"
            candidates={months}
            selectedIndex={month - 1}
            closeModal={closeMonthModal}
            modalIsOpen={monthModalIsOpen}
            itemSelect={monthItemSelect}
        />

      </Wrap>
  );
}
